import { PropTypes } from 'prop-types';
import React from 'react';
import { classnames } from 'tailwindcss-classnames';

import CardFunPairingComment from '../Cards/CardFunPairing/CardFunPairingComment';
import CardTextBasedMediumHighlight from '../Cards/CardTextBased/CardTextBasedMediumHighlight';
import CardTextBasedSmall from '../Cards/CardTextBased/CardTextBasedSmall';
import CardTextBasedXSmall from '../Cards/CardTextBased/CardTextBasedXSmall';
import TitleStrip from '../Titles/TitleStrip';

const TITLE = 'Briefings';
const LINK = {
  title: 'View All Briefings',
  url: '/briefings/',
};

const HomepageBriefings = ({ articles, comments, description }) => {
  const featuredCommentCard = comments?.[0];
  return (
    <div
      className="maxed:mx-auto maxed:w-[1920px] border-t border-b maxed:border-r border-smoke bg-snow relative"
      data-module-id="homepage_briefings"
    >
      <div className="absolute top-0 bottom-0 left-0 z-30 w-2 sm:w-3 lg:w-4 bg-grape-soda" />
      <TitleStrip description={description} link={LINK} title={TITLE} />
      <div
        className="homepage-grid-exact-container"
        data-component-id="homepage_grid_exact_container"
      >
        <div className="bg-grape-soda lg:col-span-20 sm:col-span-18 col-span-full">
          {/* featured comment */}
          <CardTextBasedMediumHighlight
            author={featuredCommentCard?.author}
            title={featuredCommentCard?.title}
            url={featuredCommentCard?.link?.url}
          />
        </div>
        <div className="grid gap-y-8 grid-flow-row lg:col-span-10 lg:col-start-[22] lg:mt-12 sm:col-start-[20] sm:col-span-5 col-start-2 col-end-[25] sm:mt-6 mt-8 h-[fit-content]">
          {articles.slice(0, 2).map((item) => {
            const { header, id, publishedDate, slug, tags, title } = item;
            return (
              <div
                key={id}
                className="pb-4 overflow-hidden border-b sm:pb-6 lg:pb-8 border-smoke"
              >
                <CardTextBasedSmall
                  date={publishedDate}
                  description={header?.headline}
                  slug={slug}
                  tags={tags}
                  title={title}
                />
              </div>
            );
          })}
        </div>
        <div className="lg:grid lg:mt-12 lg:grid-flow-row lg:col-span-7 lg:col-start-[34] hidden gap-y-10 h-[fit-content]">
          {articles.slice(2, 5).map((item) => {
            const { id, publishedDate, slug, title } = item;
            return (
              <CardTextBasedXSmall
                key={id}
                className="flex flex-col pb-8 border-b border-smoke text-hover"
                date={publishedDate}
                slug={slug}
                title={title}
              />
            );
          })}
        </div>
      </div>
      <div
        className="mt-8 mb-12 homepage-grid-container lg:mt-16 lg:mb-20 sm:mt-10 sm:mb-10 gap-y-8"
        data-component-id="homepage_briefing_article"
      >
        {comments.slice(1, 5).map((item, index) => {
          const { author, id, image, link, title: commentTitle } = item;
          const bottomHalf = index >= 2;
          return (
            <div
              key={id}
              className={classnames(
                'col-span-6',
                'lg:col-span-5',
                'sm:col-span-3',
                'sm:pt-0',
                'sm:border-t-0',
                { 'border-t': bottomHalf },
                { 'border-smoke': bottomHalf },
                { 'pt-4': bottomHalf },
              )}
            >
              <CardFunPairingComment
                author={author}
                image={image}
                title={commentTitle}
                url={link?.url}
                variant
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

HomepageBriefings.propTypes = {
  articles: PropTypes.array,
  comments: PropTypes.array,
};

export default HomepageBriefings;
